<template>
	<div class="box">
		<div class="charts-header">
			<div>
				<span @click="xzBool=!xzBool">选择数据</span>
				<div class="dxchack" v-show="xzBool">
					 <el-checkbox-group v-model="checkList">
					    <el-checkbox v-for="item in options1" :label="item.name" :key="item.id"></el-checkbox>
					  </el-checkbox-group>
				</div>
			</div>
			<div>
				<el-select v-model="value" placeholder="请选择">
				    <el-option
				      v-for="item in options2"
				      :key="item.id"
				      :label="item.name"
				      :value="item.id">
				    </el-option>
				  </el-select>
			</div>
			<div class="fr">导出数据</div>
		</div>
		<div>
			<div ref="echarts" class="echart">
  			</div>
		</div>
	</div>
</template>

<script>
	import echarts from 'echarts'
	export default{
		props: ['type','options2','options1','name'],
		data(){
			return{
				xzBool:false,
				checkList:[],
				value:1,
				chart: null,
				type:this.type,
		        option:  {
		            title: {
//		                text: 'Biu~简单柱状图示例'
		            },
		            tooltip: {},
		            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
			            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
			        },
		            legend: {
//		                data:['人数']
		            },
		            xAxis: {
		            	type: 'category',
		                data:  ["张一","张二","张三","张四","张五","张六","张七","张八","张九","张十"]
		            },
		            yAxis: {
		            	type: 'value'
		            },
		            series: [{
		                name: '人数',
		                type: 'bar',
		                data: [5, 20, 36, 10, 10, 20,50, 20,50, 20]
		            },],
		            color: ['rgba(29,181,255,1)']
		        },
		        option1:  {
		            title: {
//		                text: 'Biu~简单柱状图示例'
		            },
		            tooltip: {},
		            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
			            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
			        },
		            legend: {
//		                data:['人数']
		            },
		            xAxis: {
		            	type: 'category',
		                data: ["06.01","06.02","06.03","06.04","06.05","06.06","06.07"]
		            },
		            yAxis: {
		            	type: 'value'
		            },
		            series: [{
		                name: '正畸诊断报告',
		                type: 'line',
		                data: [5, 20, 36, 10, 10, 20,50]
		            },{
		                name: '患者沟通报告',
		                type: 'line',
		                data: [5, 10, 16, 30, 0, 40,50]
		            }],
		            color: ['rgba(29,181,255,1)','#aaaaaa']
		        }
			}
		},
		 mounted() {
	      this.getPage()
	    },
		methods: {
		    getPage() {
		        this.chart = echarts.init(this.$refs.echarts);
		        // 使用刚指定的配置项和数据显示图表。
		        if(this.type==1){
		        	this.chart.setOption(this.option1);
		        }else{
		        	this.chart.setOption(this.option);
		        }
		      }
		    }
	}
</script>

<style scoped>
	.charts-header{
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.charts-header>div:nth-child(1){
		border-bottom: 1px solid rgba(74,74,74,1);
		margin-left: 20px;
		cursor: pointer;
	}
	.charts-header>div{
		/*margin: 0 auto;*/
		font-size:15px;
		font-family:PingFangSC-Semibold,PingFang SC;
		font-weight:600;
		color:rgba(74,74,74,1);
		line-height:21px;
		position: relative;
	}
	.dxchack{
		/*width: 100px;*/
		padding: 10px;
		z-index: 999;
		background: #FFFFFF;
		/*height: 100px;*/
		position: absolute;
		left: -10px;
		border:1px solid #CCCCCC;
	}
	.charts-header>div.fr{
		font-size:15px;
		font-family:PingFangSC-Semibold,PingFang SC;
		font-weight:600;
		color:rgba(74,74,74,1);
		line-height:21px;
		border-bottom: 1px solid rgba(74,74,74,1);
		height: 20px;
		cursor: pointer;
		margin-right: 60px;
	}
	.echart{
		width: 490px;
		height: 280px;
	}
</style>


// WEBPACK FOOTER //
// src/component/fxalEcharts.vue